import * as React from 'react';

import Alert from 'src/components/common/Alert';

import locationServiceInstance from 'src/services/location/LocationService';
import env from 'src/shared/env';

import './PickUpDeliverAddressChange.scss';
import i18n from 'src/translation/i18n';

interface IDeliverAddress {
  warehouseCode: string;
  suppliedFrom: string;
  description: string;
  quantity: number;
  name: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IPickUpDeliverAddressChangeProps {
  defaultWarehouse: any;
  supplierQuantity: number;
  deliverAddresses: IDeliverAddress[];
  selectedPickup: string;
  handleClose: () => void;
  handleChangeAddress: (pickUpAddress: string) => void;
  t?: any;
}

interface IPickUpDeliverAddressChangeState {
  pickUpAddress: string;
  zipCode: string;
  deliverAddresses: IDeliverAddress[];
  alert: { show: boolean; type: string; message: string };
}

class PickUpDeliverAddressChange extends React.Component<
  IPickUpDeliverAddressChangeProps,
  IPickUpDeliverAddressChangeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      pickUpAddress: this.props.defaultWarehouse,
      zipCode: '',
      deliverAddresses: this.props.deliverAddresses,
      alert: { show: false, type: '', message: '' }
    };
  }

  private handleOnChangeZIPCode = (e: any) => {
    this.setState({ zipCode: e.target.value });
  };

  private handleSearchLocations = () => {
    const newAddresses: any[] = [];
    if (this.state.zipCode) {
      locationServiceInstance
        .getLocations(this.state.zipCode)
        .then(res => {
          if (res) {
            res.forEach(location => {
              this.state.deliverAddresses.forEach(address => {
                if (address.warehouseCode === location.code) {
                  newAddresses.push({ ...address, ...location });
                }
              });
            });
          }
          this.setState({
            deliverAddresses: newAddresses,
            alert: { show: false, type: '', message: '' }
          });
        })
        .catch(err => {
          this.setState({
            alert: {
              show: true,
              type: 'error',
              message: err.response.data.message
            }
          });
        });
    } else {
      this.setState({
        deliverAddresses: this.state.deliverAddresses,
        alert: { show: false, type: '', message: '' }
      });
    }
  };

  private handleAddressChange = (warehouse: string) => {
    this.setState({
      pickUpAddress: warehouse
    });
  };

  private handleCloseAlert = () => {
    this.setState({ alert: { show: false, type: '', message: '' } });
  };

  private formatAddress = (address: IDeliverAddress) => {
    let addressF: string = '';
    addressF +=
      address.addressLine1 && `${address.addressLine1.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine2 && `${address.addressLine2.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine4 && `${address.addressLine4.toLocaleLowerCase()}, `;
    addressF += address.stateCode && `${address.stateCode} `;
    addressF += address.postalCode && `${address.postalCode}`;
    return addressF;
  };

  public componentDidMount() {
    this.setState({
      pickUpAddress: this.props.selectedPickup
    });
  }

  private renderPickUpRow = (address: IDeliverAddress) => {
    const { t } = this.props;
    return (
      <div
        className={`rp-deliver-address-change--addresses--row ${this.state
          .pickUpAddress === address.code && 'selected'}`}
        onClick={() => this.handleAddressChange(address.warehouseCode)}
      >
        <div className="rp-deliver-address-change--addresses--address">
          <div className="rp-deliver-address-change--addresses--title-mobile">
            {t('product.store')}
          </div>
          <div className="rp-deliver-address-change--addresses--address--state">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? address.name.split(' PICK UP ONLY')[0]
              : address.name}
          </div>
          <div className="rp-deliver-address-change--addresses--address--complete">
            {this.formatAddress(address)}
          </div>
        </div>
        <div className="rp-deliver-address-change--addresses--stock">
          <div className="rp-deliver-address-change--addresses--title-mobile">
            {t('product.availability')}
          </div>
          <div>
            {address.quantity > 0
              ? `${address.quantity} ${i18n.t('common.inStock')}`
              : `${i18n.t('common.outOfStock')}`}
          </div>
        </div>
      </div>
    );
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-deliver-address-change">
        {this.state.alert.show && (
          <Alert
            type={this.state.alert.type}
            styleClass={'rp-deliver-address-change--alert'}
            message={this.state.alert.message}
            icon={
              this.state.alert.type === 'error' ? 'rpds-error' : 'rpds-shipping'
            }
            handleCloseAlert={this.handleCloseAlert}
          />
        )}
        <div className="rp-deliver-address-change--info">
          <span
            onClick={e => this.props.handleClose()}
            className="rpds-close rp-deliver-address-change--close-modal-icon"
          />
          <div className="rp-deliver-address-change--directions-text">
            {t('product.choosePickStore')}:
          </div>
          <div className="rp-deliver-address-change--addresses">
            <div className="rp-deliver-address-change--addresses--titles-desktop">
              <div className="rp-deliver-address-change--addresses--title-store-desktop">
                {t('product.store')}
              </div>
              <div className="rp-deliver-address-change--addresses--title-availability-desktop">
                {t('product.availability')}
              </div>
            </div>
            {this.props.deliverAddresses.length > 0 &&
              this.props.deliverAddresses.map(address => (
                <div key={address.warehouseCode} className="rp-deliver-wrapper">
                  <div className="rp-divider" />
                  {this.renderPickUpRow(address)}
                </div>
              ))}
          </div>
          <div className="rp-deliver-address-change--supplier">
            {t('product.manufacturerQuantity')}
            <span className="rp-deliver-address-change--supplier-count">
              {this.props.supplierQuantity}
            </span>
          </div>
          <div className="rp-deliver-address-change--button">
            <button
              className="primary-button"
              onClick={e =>
                this.props.handleChangeAddress(this.state.pickUpAddress)
              }
            >
              {t('common.changeStore')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default PickUpDeliverAddressChange;
